
const axios = require('axios');

export default class SFRestManager {
	static getAccessToken = function (code, successCallback, failureCallback) {
		axios.post('/getSalesforceAccessToken', {
			code: code
		})
			.then((response) => {
				// console.log('login succeed');
				successCallback(response);
			})
			.catch((error) => {
				// console.log("error is");
				failureCallback(error);
			});
	}

	static getAccessTokenFromRefreshToken = (refresh_token, guest_name, guest_email, guest_company_name, guest_title, successCallback, failureCallback) => {
		axios.post('/getSalesforceAccessTokenFromRefreshToken', {
			refresh_token: refresh_token
		}).then((response) => {
			successCallback(response, guest_name, guest_email, guest_company_name, guest_title);
		}).catch((error) => {
			failureCallback(error, guest_name, guest_email, guest_company_name, guest_title);
		});
	}

	static checkProfileDetails = (accessToken, instanceURL, queryObj, guest_name, guest_email, guest_company_name, guest_title, successCallback, failureCallback) => {
		var reqData = {
			data: queryObj,
			accessToken: accessToken,
			instanceURL: instanceURL
		}
		axios.post('/getSFProfileDetails', reqData).then((response) => {
			successCallback(response, guest_name, guest_email, guest_company_name, guest_title);
		}).catch((error) => {
			failureCallback(error, guest_name, guest_email, guest_company_name, guest_title);
		});
	}

	static getAccountDetails = function (accessToken, instanceURL, id, successCallback, failureCallback) {
		var req = {
			data: id,
			accessToken: accessToken,
			instanceURL: instanceURL
		}
		axios({
			type: 'GET',
			url: '/getSFAccountDetails',
			data: req,
			success: function (response) {
				successCallback(response);
			},
			error: function (err) {
				failureCallback(err);
			}
		})
	}

	static createSFLead = function (accessToken, instanceURL, reqObj, taskSubject, taskDetails, taskStatus, taskDate, successCallback, failureCallback) {
		var reqData = {
			data: reqObj,
			accessToken: accessToken,
			instanceURL: instanceURL
		}

		axios.post('/createSFLead', reqData).then((response) => {
			console.log('createSFLead succeed');
			successCallback(response, taskSubject, taskDetails, taskStatus, taskDate);
		}).catch((error) => {
			console.log("createSFLead error is");
			failureCallback(error, taskSubject, taskDetails, taskStatus, taskDate);
		});
	}

	static createSFActivity = function (accessToken, instanceURL, reqObj, successCallback, failureCallback) {
		var reqData = {
			data: reqObj,
			accessToken: accessToken,
			instanceURL: instanceURL
		}

		axios.post('/createSFActivity', reqData).then((response) => {
			console.log('createSFActivity succeed');
			successCallback(response);
		}).catch((error) => {
			console.log("createSFActivity error is ", error);
			failureCallback(error);
		});
	}

	static createBulkLead = function (accessToken, instanceURL, data, successCallback, failureCallback) {
		let baseData = {
			fields: ['id'],
			sobjects: [
				{fields: ['id'], name: 'Contact', limit: 20},
				{fields: ['id'], name: 'Lead'}
			],
			in: 'ALL',
			overallLimit: 100,
			defaultLimit: 10
		}

		const reqData = {
			baseData: baseData,
			guests: data,
			accessToken: accessToken,
			instanceURL: instanceURL
		}

		axios.post('/createSFBulkLead', reqData).then((response) => {
			successCallback(response);
		}).catch(error => {
			failureCallback(error);
		})
	}

	static createBulkTask = function (accessToken, instanceURL, taskData, guests, successCallback, failureCallback) {
		let baseData = {
			fields: ['id'],
			sobjects: [
				{fields: ['id'], name: 'Contact', limit: 20},
				{fields: ['id'], name: 'Lead'}
			],
			in: 'ALL',
			overallLimit: 100,
			defaultLimit: 10
		}

		let reqData = {
			baseData: baseData,
			taskData: taskData,
			guests: guests,
			accessToken: accessToken,
			instanceURL: instanceURL
		}

		axios.post('/createSFBulkActivity', reqData).then((response) => {
			successCallback(response);
		}).catch(error => {
			failureCallback(error);
		})
	}
}